module.exports = __webpack_public_path__ + "img/3.593a0de8.jpg";